/**
 * An in-memory cache to keep record of:
 . all possible states and/or analytic events for a widget
 */
import WidgetTypes from './enums/WidgetTypes';
import AnalyticsCategories from './enums/AnalyticsCategories';
import AnalyticsEvents from './enums/AnalyticsEvents';
import ChatStates from './hooks/ChatStates';
import ChatEvents from './hooks/ChatEvents';
import WidgetStates from './hooks/WidgetStates';

const WidgetStateEventRegistery = function () {
    const registery = {};
    registery[WidgetTypes.DropDown] = [
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.InvitationRequested,
            state: WidgetStates.Requested,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.InvitationAvailable,
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.InvitationReady,
            state: WidgetStates.Ready,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Created,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownNormal,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownMinimized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.InvitationShown,
            state: WidgetStates.ShownMaximized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownCollapsed,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.InvitationClicked,
            state: WidgetStates.Clicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.PoppedOut,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.VisitorFormClicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.DynamicVisitorFormClicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.VideoClicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Closed,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Hidden,
            maintainCookie: true
        }
    ];
    registery[WidgetTypes.Windowed] = [
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.Ready,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.Created,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.ShownNormal,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.ShownMinimized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.ChatWindowLoaded,
            state: WidgetStates.ShownMaximized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.ChatStarted,
            state: ChatStates.Started,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.PoppedOut,
            maintainCookie: true
        }
    ];
    registery[WidgetTypes.ExitPopup] = [
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Ready,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Created,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownNormal,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownMinimized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.ChatStarted,
            state: ChatStates.Started,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownMaximized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Clicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Closed,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Hidden,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.MouseExit,
            maintainCookie: false
        }
    ];
    registery[WidgetTypes.Tab] = [
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Ready,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Created,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownNormal,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownMaximized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownMinimized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Clicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.VisitorFormClicked,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.DynamicVisitorFormClicked,
            maintainCookie: false
        }
    ];
    registery[WidgetTypes.PopupMessage] = [
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Ready,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Created,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownNormal,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownMaximized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownMinimized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Clicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.VisitorFormClicked,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.DynamicVisitorFormClicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Hidden,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Closed,
            maintainCookie: true
        }
    ];
    registery[WidgetTypes.Bar] = [
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Ready,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Created,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownNormal,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownMaximized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Clicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.VisitorFormClicked,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.DynamicVisitorFormClicked,
            maintainCookie: false
        }
    ];
    registery[WidgetTypes.SMS] = [
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Ready,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Created,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownNormal,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Clicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.SMSRequested,
            state: ChatStates.SMSClicked,
            maintainCookie: false
        }
    ];
    registery[WidgetTypes.Static] = [
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Clicked,
            maintainCookie: false
        }
    ];
    registery[WidgetTypes.DOM] = [
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.Ready,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.Created,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.ShownNormal,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.ShownMinimized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.ShownMaximized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.Clicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.Closed,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.Hidden,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.MessageSent,
            maintainCookie: false
        },

        {
            category: AnalyticsCategories.Chat,
            event: AnalyticsEvents.ChatRefreshed,
            state: ChatStates.Refreshed,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.ChatStarted,
            state: ChatStates.Started,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatStates.Ended,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatStates.ChatRoomClicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: WidgetStates.PoppedOut,
            maintainCookie: true
        }
    ];
    registery[WidgetTypes.VisitorForm] = [
        {
            category: '',
            event: '',
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        { category: '', event: '', state: WidgetStates.Ready, maintainCookie: false },
        { category: '', event: '', state: WidgetStates.Created, maintainCookie: false },
        { category: '', event: '', state: WidgetStates.ShownNormal, maintainCookie: true },
        {
            category: '',
            event: '',
            state: WidgetStates.ShownMaximized,
            maintainCookie: true
        },
        { category: '', event: '', state: WidgetStates.Closed, maintainCookie: true },
        {
            category: '',
            event: '',
            state: WidgetStates.VisitorFormSubmitted,
            maintainCookie: true
        }
    ];
    registery[WidgetTypes.DynamicVisitorForm] = [
        {
            category: '',
            event: '',
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        { category: '', event: '', state: WidgetStates.Ready, maintainCookie: false },
        { category: '', event: '', state: WidgetStates.Created, maintainCookie: false },
        { category: '', event: '', state: WidgetStates.ShownNormal, maintainCookie: true },
        {
            category: '',
            event: '',
            state: WidgetStates.ShownMaximized,
            maintainCookie: true
        },
        { category: '', event: '', state: WidgetStates.Closed, maintainCookie: true },
        {
            category: '',
            event: '',
            state: WidgetStates.DynamicVisitorFormCancelled,
            maintainCookie: true
        },
        {
            category: '',
            event: '',
            state: WidgetStates.DynamicVisitorFormSubmitted,
            maintainCookie: true
        }
    ];
    registery[WidgetTypes.ChatRoom] = [
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnChatJoinFailure,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnSendMessage,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnSendMessageSuccess,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnSendMessageFailure,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnMessageTyping,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnTypingArrived,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnMessageArrived,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnStopWaiting,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnParticipantsChanged,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnHideWaitingIndicator,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnCallStatusArrived,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnChatEnded,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnChatJoined,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnTransferRequested,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnSMSChatTransferring,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnSMSChatTransferred,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.ChatRequested,
            state: ChatStates.Requested,
            maintainCookie: false
        }
    ];
    registery[WidgetTypes.DOMUIController] = [
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnTypingArrived,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnMessageIncoming,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.Ended,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnChatRestart,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnTransferRequested,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.ChatGreetingShown,
            state: ChatStates.GreetingShown,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.ChatUIRendered,
            state: ChatStates.UIRendered,
            maintainCookie: true
        }
    ];
    registery[WidgetTypes.EPUIController] = [
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnTypingArrived,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnMessageIncoming,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.Ended,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnChatRestart,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Chat,
            event: '',
            state: ChatEvents.OnTransferRequested,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.ChatGreetingShown,
            state: ChatStates.GreetingShown,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: AnalyticsEvents.ChatUIRendered,
            state: ChatStates.UIRendered,
            maintainCookie: false
        }
    ];
    registery[WidgetTypes.PreChat] = [
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Ready,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Created,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.ShownNormal,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.ShownMaximized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.ShownMinimized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Clicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Hidden,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.VisitorFormClicked,
            maintainCookie: false
        }
    ];
    registery[WidgetTypes.WebSmsForm] = [
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Ready,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Created,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.ShownNormal,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.ShownMaximized,
            maintainCookie: true
        },
        // { category: AnalyticsCategories.Invitation, event: null, state: WidgetStates.ShownMinimized, maintainCookie: true },
        // { category: AnalyticsCategories.Invitation, event: null, state: WidgetStates.Clicked, maintainCookie: false },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Hidden,
            maintainCookie: true
        }
        // { category: AnalyticsCategories.Invitation, event: '', state: WidgetStates.VisitorFormClicked, maintainCookie: false },
    ];
    registery[WidgetTypes.PokeMessagesOverLay] = [
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Hidden,
            maintainCookie: true
        }
    ];

    registery[WidgetTypes.Test] = [
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Requested,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Ready,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Created,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownNormal,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.ShownMaximized,
            maintainCookie: true
        }
    ];
    registery[WidgetTypes.VideoGreetInvitation] = [
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Initialized,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Ready,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Created,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.ShownNormal,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.ShownMaximized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.ShownMinimized,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Clicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: null,
            state: WidgetStates.Hidden,
            maintainCookie: true
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.VisitorFormClicked,
            maintainCookie: false
        },
        {
            category: AnalyticsCategories.Invitation,
            event: '',
            state: WidgetStates.Closed,
            maintainCookie: true
        }
    ];
    registery.getEntry = function (w, s) {
        const states = registery[w];
        if (s) {
            return states.find((st) => st.state === s);
        }
        return states;
    };
    return registery;
};
export default WidgetStateEventRegistery;
